import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { MainStoreState } from 'modules/main/store/MainStoreState';

export const useMainSelector: TypedUseSelectorHook<MainStoreState> =
  useSelector;
